import React from 'react';
import {
  GlobeMulticulturalIcon,
  CanadaFlagIcon,
  WholesalePricingIcon,
  InteracIcon,
} from '../icons/CategoryIcons';

const TRUST_ITEMS = [
  { Icon: GlobeMulticulturalIcon, label: 'Multicultural Wholesale', sub: 'Products for every community', accent: 'bg-brand-green/10' },
  { Icon: CanadaFlagIcon, label: 'GTA Based', sub: 'Ships across Canada', accent: 'bg-brand-red/10' },
  { Icon: WholesalePricingIcon, label: 'Wholesale Pricing', sub: 'Bulk rates for businesses', accent: 'bg-brand-gold/10' },
  { Icon: InteracIcon, label: 'Interac e-Transfer', sub: 'Simple, secure payment', accent: 'bg-brand-green/10' },
];

const TrustBar: React.FC = () => {
  return (
    <section className="bg-white border-b border-gray-100 py-7 px-5 sm:px-10" aria-label="Trust indicators">
      <div className="max-w-[1280px] mx-auto flex flex-wrap items-center justify-between gap-5">
        {TRUST_ITEMS.map((item) => (
          <div key={item.label} className="flex items-center gap-3">
            <div className={`w-[42px] h-[42px] ${item.accent} rounded-[10px] flex items-center justify-center flex-shrink-0`}>
              <item.Icon size={26} />
            </div>
            <div>
              <div className="font-semibold text-sm text-brand-navy">{item.label}</div>
              <div className="text-xs text-brand-text-muted">{item.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustBar;
